import { IsFunction } from "@Utils/Assertions";
import E from "linq";

interface KeyValuePair<T> {
    key: T;
    value: any;
}

export function EnumerableFromObject2<T,
    K = T extends object ? keyof T : string>(obj: any): E.IEnumerable<KeyValuePair<K>> {

    const array: KeyValuePair<any>[] = [];

    for (const key in obj) {
        if (!IsFunction(obj[key])) {
            array.push({ key, value: obj[key] });
        }
    }

    return E.from(array);
}
